import React from 'react';
import { Dropdown } from 'react-bootstrap';
import styles from '../Chart.module.css';
import commonStyles from '../../../ManagementPages.module.css';

/**
 * Reusable header component for vital cards
 * @param {React.Component} Icon - Icon component to display
 * @param {string} vitalName - Name of the vital to display
 * @param {string} measurement - Measurement value to display
 * @param {string} latestDate - Latest date string to display
 */
const VitalCardHeader = ({
  Icon,
  vitalName,
  measurement,
  latestDate,
  outOfRangeCount,
  lastCalibrationDate,
  triggerCalibration,
  triggerReading,
}) => {
  const showBpDropdown = triggerCalibration || triggerReading;
  const showAverageLabel = measurement && !String(measurement).includes('No Data') && latestDate === 'Interval Average';
  const showOutOfRange = outOfRangeCount != null && outOfRangeCount > 0;
  const showLatestDate = latestDate && latestDate !== 'Interval Average';
  const detailSections = [];

  if (vitalName !== 'Audio') {
    detailSections.push({
      key: 'measurement',
      content: (
        <div className={styles.measurement}>
          <span className={styles.value}>{measurement}</span>
          {showAverageLabel && <span className={styles.averageLabel}>(Average)</span>}
        </div>
      ),
    });
  }

  if (showLatestDate) {
    detailSections.push({
      key: 'latestDate',
      content: <div className={styles.latestDate}>{latestDate}</div>,
    });
  }

  if (showOutOfRange) {
    detailSections.push({
      key: 'outOfRange',
      content: <div className={styles.latestDate}>{outOfRangeCount} out of range</div>,
    });
  }

  if (lastCalibrationDate) {
    detailSections.push({
      key: 'lastCalibrationDate',
      content: <div className={styles.latestDate}>Last Calibrated: {lastCalibrationDate}</div>,
    });
  }


  return (
    <div className={styles.header} style={showBpDropdown ? { marginBottom: '10px' } : {}}>
      <div className={styles.headerSection}>
        {Icon && <Icon className={styles.icon} />}
        <span className={styles.vitalName}>{vitalName}</span>
      </div>
      {detailSections.map((section) => (
        <div key={section.key} className={`${styles.headerSection} ${styles.divider}`}>
          {section.content}
        </div>
      ))}
      {showBpDropdown && (
        <>
          <div style={{ flex: 1 }} />
          <Dropdown>
            <Dropdown.Toggle
            style={{ minWidth: 'fit-content'}}
              className={commonStyles.TertiaryButton}
              id="initiate-bp-dropdown"
            >
              Initiate
            </Dropdown.Toggle>
            <Dropdown.Menu className="custom-bootstrap-menu">
              {triggerCalibration && (
                <Dropdown.Item onClick={triggerCalibration}>Calibration</Dropdown.Item>
              )}
              {triggerReading && (
                <Dropdown.Item onClick={triggerReading}>Reading</Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </>
      )}
    </div>
  );
};

export default VitalCardHeader;
